var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-icon',{staticClass:"icon",attrs:{"color":_vm.$attrs.color,"small":""}},[_vm._v("far fa-copy")])
}
var staticRenderFns = []

export { render, staticRenderFns }